/**
 * useIssue Application Hook
 */

import { IssuesService } from '../support/services/api';

export default function useIssue() {
  const createIssue = ({ user, message }) => {
    const name = user?.name || 'anonymous';
    const whatsapp = user?.whatsapp || '99999999999';

    IssuesService().create({ name, whatsapp }, message);
  };

  return {
    commands: {
      createIssue,
    },
    sharedStates: {
    },
  };
}
